import { gql } from "@apollo/client";

export const UpdateMachine = gql`
	mutation UpdateMachine($input: JSON) {
		updateMachine(input: $input)
	}
`;
